//class
import PadCreator from '../PadCreator';
import BuildPadDiagnostic from './BuildPadDiagnostic';
// utils
import _ from 'lodash';
import { codeGeneretor, keepObjectProperties } from 'app/utils';
// config
// import { PAD_CARD_TYPES } from 'app/config/pad';
import { PAD_ALTERATION_TYPE } from 'app/config/pad';

const { CREATION /* , ALTERATION */ } = PAD_ALTERATION_TYPE;

/**
 * represents an instance of PadDiagnostic
 * @class PadDiagnostic
 * @extends PadCreator
 */
export default class PadDiagnostic extends PadCreator {
  prepare(padDiagnostics) {
    const preparedPadDiagnostics = padDiagnostics.map(padDiagnostic => {
      const code = codeGeneretor();

      return (
        new BuildPadDiagnostic(padDiagnostic)
          .cleanPadDiagnostic(keepObjectProperties)
          // .addPadCardType(PAD_CARD_TYPES.DIAGNOSTIC)
          .setPadDiagnostic(padDiagnostic)
          .addPadDiagnosticCode(code)
          .addStatus(1)
          .getPadDiagnostic()
      );
    });

    this._loadedData = _.cloneDeep(padDiagnostics);
    this._screenData = _.cloneDeep(preparedPadDiagnostics);
    this._submitData = _.cloneDeep(preparedPadDiagnostics);

    return this;
  }

  /**
   * add a new pad diagnostic.
   * @param {object} padDiagnostic - padDiagnostic to be added.
   * @returns {object} the state
   */
  add(padDiagnostic) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const code = codeGeneretor();

    const padDiagnosticToAdd = new BuildPadDiagnostic(padDiagnostic)
      .addPadDiagnosticCode(code)
      .addStatus(1)
      .addPadDiagnosticType(CREATION)
      // .addPadCardType(PAD_CARD_TYPES.DIAGNOSTIC)
      .getPadDiagnostic();

    this._screenData = [...cScreenData, padDiagnosticToAdd];
    this._submitData = [...cSubmitData, padDiagnosticToAdd];

    return this;
  }

  /**
   * update a pad diagnostic.
   * @param {object} padDiagnostic - padDiagnostic to be edited.
   * @returns {object} return the state
   */
  edit(padDiagnostic) {
    const screenData = _.cloneDeep(this._screenData);
    const submitData = _.cloneDeep(this._submitData);

    const padDiagnosticEdited = new BuildPadDiagnostic({ ...padDiagnostic })
      .setUpdateStatus()
      .getPadDiagnostic();

    const indexScreen = screenData.findIndex(padDiag => padDiag.code === padDiagnosticEdited.code);
    screenData.splice(indexScreen, 1, padDiagnosticEdited);

    const indexSubmit = submitData.findIndex(padDiag => padDiag.code === padDiagnosticEdited.code);
    submitData.splice(indexSubmit, 1, padDiagnosticEdited);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * remove a element.
   * @param {object} padDiagnostic - padDiagnostic to be removed.
   * @returns {object} return the state
   */
  remove(padDiagnostic) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const screenData = cScreenData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);
    const submitData = cSubmitData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * suspend a pad diagnostic.
   * @param {object} padDiagnostic - padDiagnostic to be suspended.
   * @returns {object} return the state
   */
  // suspend(padDiagnostic) {
  //   const cScreenData = _.cloneDeep(this._screenData);
  //   const cSubmitData = _.cloneDeep(this._submitData);

  //   const screenData = cScreenData.map(pDiagnostic => {
  //     if (pDiagnostic.id === padVisit.id) {
  //       return BuildPadDiagnostic.setPadDiagnostic(padDiagnostic)
  //         .suspendPadDiagnostic(padDiagnostic.id)
  //         .getPadDiagnostic();
  //     }
  //     return pDiagnostic;
  //   });

  //   const pDiagnostic = screenData.find(pDiagnostic => pDiagnostic.code === padDiagnostic.code);

  //   const submitData = [...cSubmitData, pDiagnostic];

  //   this._screenData = _.cloneDeep(screenData);
  //   this._submitData = _.cloneDeep(submitData);

  //   return this;
  // }

  /**
   * unsuspend a pad visit.
   * @param {object} padDiagnostic - padDiagnostic to be unsuspended.
   * @returns {object} return the state
   */
  // unsuspend(padDiagnostic) {
  //   const cScreenData = _.cloneDeep(this._screenData);
  //   const cSubmitData = _.cloneDeep(this._submitData);

  //   const screenData = cScreenData.map(pDiagnostic => {
  //     if (pDiagnostic.id === padDiagnostic.id) {
  //       return buildPadDiagnostic
  //         .setPadDiagnostic(pDiagnostic)
  //         .unsuspendPadDiagnostic()
  //         .getPadDiagnostic();
  //     }
  //     return pDiagnostic;
  //   });

  //   const submitData = cSubmitData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);

  //   this._screenData = _.cloneDeep(screenData);
  //   this._submitData = _.cloneDeep(submitData);

  //   return this;
  // }
}
